import { CloseButton } from '@/components/ui/close-button';
import { DialogContent, DialogRoot, DialogTitle } from '@/components/ui/dialog';
import { Stack } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function BillingModalFrame({
  children,
  onClose,
  dismissible = true,
}: {
  children: ReactNode;
  onClose: () => void;
  /** False while the organization has no access: billing is the only way forward. */
  dismissible?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <DialogRoot
      open
      closeOnEscape={dismissible}
      closeOnInteractOutside={dismissible}
      onOpenChange={({ open }) => {
        if (!open && dismissible) onClose();
      }}
    >
      <DialogContent maxW="520px" w="calc(100vw - 32px)" bg="white" boxShadow="none" p={6}>
        {dismissible && (
          <CloseButton
            position="absolute"
            top={3}
            right={3}
            aria-label={t('common.close')}
            onClick={onClose}
          />
        )}
        <Stack gap={5}>
          <DialogTitle pr={10}>{t('settings.subscription.title')}</DialogTitle>
          {children}
        </Stack>
      </DialogContent>
    </DialogRoot>
  );
}
